<!--
 * @Author: your name
 * @Date: 2020-03-13 16:31:00
 * @LastEditTime: 2020-04-10 10:27:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/Apply.vue
 -->
<template>
  <div class="hospital"  :style="`background: url('${require('../assets/bg20.png')}'); background-size: 100% 100%;`">
   <img class="sub-logo2" src="../assets/logo5.png">
  <div class="content">
    <div class="body">
        <div class="header">
            <img class="hospital2" src="../assets/hospital2.png">
            <div class="title">医院介绍</div>
        </div>
        <div class="content2">
            <div class="hospiltalList">
                咨询机构电话及咨询热线：
                北京大学第六医院（北京大学精神卫生研究所）
                咨询电话： 010-82801939/1936
                首都医科大学附属北京安定医院 
                咨询电话：010-58303000/3063 
                北京回龙观医院 
                咨询电话：010-83024000
                北京经济技术开发区心理援助免费热线电话
                15010289074
            </div>
        </div>
    </div>
  </div>
  <share></share>
  </div>
</template>

<script>
import { Http } from '@/utils/http.js'
import api   from '@/config/api.js'
import Cookies from 'js-cookie'
import axios from 'axios'


export default {
  name: 'Apply',
  data() {
    return {
    };
  },

  methods: {

  },
  mounted: function() {
 
  }

};
</script>

<style lang="less" scoped>
.hospital {
  font-size: 16px;
    display: flex;
    height: 100vh;
    flex-direction: column;

     .sub-logo2 {
        position: absolute;
        width: 40px;
        top: 20px;
        right: 20px;    
    }
  .content {
    position: relative;
    overflow: hidden;
    height: 90%;
    background-color: #fff;
    margin: 60px 20px;
    .header{
        .hospital2{
            width: 100%;
            height: 200px;
        }
        .title {
            font-size: 20px;
          text-align: center;
          height: 20px;
          line-height: 20px;
          color: #028fe1;
        }
    }
    .content2 {
         white-space: pre-line;
        font-size: 12px;
        padding-left: 24px;
        padding-right: 24px;
        text-align: left;
        margin-top: 12px;
        .hospiltalList {
            height: 180px;
            overflow-y: scroll;
            overflow-x: hidden;
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Hospital.vue